var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "warehousing-detail" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            "label-width": "100px",
            "label-position": "right",
            "show-message": false
          }
        },
        [
          _c("el-collapse", { attrs: { value: _vm.collapse } }, [
            _c(
              "div",
              {
                staticClass: "section",
                staticStyle: { width: "80%", "min-width": "1000px" }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("Warehouse.JobNumberInformation")))
                ]),
                _c(
                  "div",
                  {
                    staticClass: "form-row",
                    staticStyle: { display: "flex", "flex-direction": "row" }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: {
                          "label-width": "100px",
                          "label-position": "right",
                          disabled: true
                        }
                      },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SeaExport.BusinessNo"),
                                      prop: "jobNo"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { no: "1" },
                                      model: {
                                        value: _vm.form.jobNo,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "jobNo", $$v)
                                        },
                                        expression: "form.jobNo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.getLob()
                                        ? _vm.$t("RailwayExport.ETD")
                                        : "ETD",
                                      prop: "ETD"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { no: "2" },
                                      model: {
                                        value: _vm.form.etdString,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "etdString", $$v)
                                        },
                                        expression: "form.etdString"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.getLob()
                                        ? _vm.$t("SeaExport.departureStation")
                                        : _vm.$t("SeaExport.PortOfLoadingAI"),
                                      prop: "portOfLoading"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { no: "3" },
                                      model: {
                                        value: _vm.form.loadingPortEnglish,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "loadingPortEnglish",
                                            $$v
                                          )
                                        },
                                        expression: "form.loadingPortEnglish"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.getMAWBName(),
                                      prop: "mbl"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { no: "4" },
                                      model: {
                                        value: _vm.form.mbl,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "mbl", $$v)
                                        },
                                        expression: "form.mbl"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.getCarrierName(),
                                      prop: "carrierId"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { no: "5" },
                                      model: {
                                        value: _vm.form.carrierName,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "carrierName", $$v)
                                        },
                                        expression: "form.carrierName"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.getLob()
                                        ? _vm.$t("SeaExport.destinationStation")
                                        : _vm.$t("SeaExport.PortOfDestination"),
                                      prop: "portOfDestination"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { no: "6" },
                                      model: {
                                        value: _vm.form.destinationPortEnglish,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "destinationPortEnglish",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.destinationPortEnglish"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.getHblName(),
                                      prop: "hbl"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { no: "7" },
                                      model: {
                                        value: _vm.form.hbl,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "hbl", $$v)
                                        },
                                        expression: "form.hbl"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.getFlightAndTime(),
                                      prop: "flightAndTime"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { no: "8" },
                                      model: {
                                        value: _vm.form.flightAndTime,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "flightAndTime",
                                            $$v
                                          )
                                        },
                                        expression: "form.flightAndTime"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.$checkPermission([
                                          "button_SEBooking_addSEBooking"
                                        ]),
                                        expression:
                                          "$checkPermission(['button_SEBooking_addSEBooking'])"
                                      }
                                    ],
                                    attrs: {
                                      label: _vm.$t(
                                        "SeaExport.ConsignationCompany"
                                      ),
                                      prop: "customerName"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        no: "9",
                                        title: _vm.form.customerName
                                      },
                                      model: {
                                        value: _vm.form.customerName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "customerName",
                                            $$v
                                          )
                                        },
                                        expression: "form.customerName"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: this.$t("CargoMsg.Cargo_Marks"),
                                      prop: "mark"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        no: "jobMark",
                                        type: "textarea",
                                        rows: 5,
                                        size: "min"
                                      },
                                      model: {
                                        value: _vm.form.jobMark,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "jobMark", $$v)
                                        },
                                        expression: "form.jobMark"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "auto-width",
                                attrs: { label: "", "label-width": "120px" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "space-between"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "font-size": "12px",
                                          "font-weight": "normal",
                                          color: "#404144",
                                          width: "110px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.Quantity"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "font-size": "12px",
                                          "font-weight": "normal",
                                          color: "#404144",
                                          width: "110px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.Weight")) +
                                            _vm._s(
                                              _vm.openImperial ? "LB" : "KGS"
                                            )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "font-size": "12px",
                                          "font-weight": "normal",
                                          color: "#404144",
                                          width: "110px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.Cubage")) +
                                            _vm._s(
                                              _vm.openImperial ? "CFT" : "CBM"
                                            )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "font-size": "12px",
                                          "font-weight": "normal",
                                          color: "#404144",
                                          width: "110px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.ChargedWeight")
                                          ) +
                                            _vm._s(
                                              _vm.openImperial ? "LB" : "KGS"
                                            )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "font-size": "12px",
                                          "font-weight": "normal",
                                          color: "#404144",
                                          width: "110px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("queryJob.Density")) +
                                            "kg/m³"
                                        )
                                      ]
                                    ),
                                    _vm.showImperialButton
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "font-size": "12px",
                                              "font-weight": "normal",
                                              color: "#404144",
                                              "white-space": "nowrap",
                                              width: "200px",
                                              "text-align": "right"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_ImperialUnits"
                                                  )
                                                ) +
                                                " "
                                            ),
                                            _c(
                                              "div",
                                              {
                                                class: _vm.openImperial
                                                  ? "el-switch is-checked"
                                                  : "el-switch"
                                              },
                                              [
                                                _c("span", {
                                                  staticClass:
                                                    "el-switch__core",
                                                  staticStyle: {
                                                    width: "40px"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.openImperial = !_vm.openImperial
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            ),
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                      "text-align": "right",
                                      "min-width": "100px"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          width: "100%",
                                          "padding-right": "10px"
                                        }
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("SeaExport.Consignation")
                                            ) + " "
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: { "label-width": "0px" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "justify-content": "space-between",
                                          "align-items": "center"
                                        }
                                      },
                                      [
                                        _c("auto-number-input", {
                                          staticClass: "contract-input",
                                          attrs: {
                                            no: "90",
                                            precision: 0,
                                            min: 0,
                                            disabled: true
                                          },
                                          model: {
                                            value: _vm.form.quantityContract,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "quantityContract",
                                                $$v
                                              )
                                            },
                                            expression: "form.quantityContract"
                                          }
                                        }),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.openImperial,
                                                expression: "openImperial"
                                              }
                                            ],
                                            staticStyle: { display: "flex" }
                                          },
                                          [
                                            _c("auto-number-input", {
                                              staticClass: "contract-input",
                                              attrs: {
                                                no: "weightContractImperial",
                                                precision: 2,
                                                min: 0,
                                                disabled: true
                                              },
                                              model: {
                                                value:
                                                  _vm.form
                                                    .weightContractImperial,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "weightContractImperial",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.weightContractImperial"
                                              }
                                            }),
                                            _c("auto-number-input", {
                                              staticClass: "contract-input",
                                              attrs: {
                                                no: "cubAgeContractImperial",
                                                precision: 3,
                                                min: 0,
                                                disabled: true
                                              },
                                              model: {
                                                value:
                                                  _vm.form
                                                    .cubAgeContractImperial,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "cubAgeContractImperial",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.cubAgeContractImperial"
                                              }
                                            }),
                                            _c("auto-number-input", {
                                              staticClass: "contract-input",
                                              attrs: {
                                                no: "chargeWeightImperial",
                                                precision: 3,
                                                min: 0,
                                                disabled: true
                                              },
                                              model: {
                                                value:
                                                  _vm.form.chargeWeightImperial,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "chargeWeightImperial",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.chargeWeightImperial"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !_vm.openImperial,
                                                expression: "!openImperial"
                                              }
                                            ],
                                            staticStyle: { display: "flex" }
                                          },
                                          [
                                            _c("auto-number-input", {
                                              staticClass: "contract-input",
                                              attrs: {
                                                no: "91",
                                                precision: 3,
                                                min: 0,
                                                disabled: true
                                              },
                                              model: {
                                                value: _vm.form.weightContract,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "weightContract",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.weightContract"
                                              }
                                            }),
                                            _c("auto-number-input", {
                                              staticClass: "contract-input",
                                              attrs: {
                                                no: "92",
                                                precision: 3,
                                                min: 0,
                                                disabled: true
                                              },
                                              model: {
                                                value: _vm.form.cubageContract,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "cubageContract",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.cubageContract"
                                              }
                                            }),
                                            _c("auto-number-input", {
                                              staticClass: "contract-input",
                                              attrs: {
                                                no: "93",
                                                precision: 3,
                                                min: 0,
                                                disabled: true
                                              },
                                              model: {
                                                value: _vm.form.chargeWeight,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "chargeWeight",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.chargeWeight"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c("auto-number-input", {
                                          staticClass: "contract-input",
                                          attrs: {
                                            precision: 3,
                                            min: 0,
                                            no: "140",
                                            disabled: true
                                          },
                                          model: {
                                            value: _vm.form.densityContract,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "densityContract",
                                                $$v
                                              )
                                            },
                                            expression: "form.densityContract"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                      "text-align": "right",
                                      "min-width": "100px"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          width: "100%",
                                          "padding-right": "10px"
                                        }
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("SeaExport.Booking")
                                            ) + " "
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: { "label-width": "0px" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "justify-content": "space-between"
                                        }
                                      },
                                      [
                                        _c("auto-number-input", {
                                          staticClass: "contract-input",
                                          attrs: {
                                            no: "94",
                                            precision: 0,
                                            min: 0,
                                            disabled: true
                                          },
                                          model: {
                                            value: _vm.form.quantityBooking,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "quantityBooking",
                                                $$v
                                              )
                                            },
                                            expression: "form.quantityBooking"
                                          }
                                        }),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.openImperial,
                                                expression: "openImperial"
                                              }
                                            ]
                                          },
                                          [
                                            _c("auto-number-input", {
                                              staticClass: "contract-input",
                                              attrs: {
                                                no: "weightBookingImperial",
                                                precision: 2,
                                                min: 0,
                                                disabled: true
                                              },
                                              model: {
                                                value:
                                                  _vm.form
                                                    .weightBookingImperial,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "weightBookingImperial",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.weightBookingImperial"
                                              }
                                            }),
                                            _c("auto-number-input", {
                                              staticClass: "contract-input",
                                              attrs: {
                                                no: "cubAgeBookingImperial",
                                                precision: 3,
                                                min: 0,
                                                disabled: true
                                              },
                                              model: {
                                                value:
                                                  _vm.form
                                                    .cubAgeBookingImperial,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "cubAgeBookingImperial",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.cubAgeBookingImperial"
                                              }
                                            }),
                                            _c("auto-number-input", {
                                              staticClass: "contract-input",
                                              attrs: {
                                                no:
                                                  "chargeWeightBookingImperial",
                                                precision: 3,
                                                min: 0,
                                                disabled: true
                                              },
                                              model: {
                                                value:
                                                  _vm.form
                                                    .chargeWeightBookingImperial,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "chargeWeightBookingImperial",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.chargeWeightBookingImperial"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !_vm.openImperial,
                                                expression: "!openImperial"
                                              }
                                            ]
                                          },
                                          [
                                            _c("auto-number-input", {
                                              staticClass: "contract-input",
                                              attrs: {
                                                no: "95",
                                                precision: 3,
                                                min: 0,
                                                disabled: true
                                              },
                                              model: {
                                                value: _vm.form.weightBooking,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "weightBooking",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.weightBooking"
                                              }
                                            }),
                                            _c("auto-number-input", {
                                              staticClass: "contract-input",
                                              attrs: {
                                                no: "96",
                                                precision: 3,
                                                min: 0,
                                                disabled: true
                                              },
                                              model: {
                                                value: _vm.form.cubageBooking,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "cubageBooking",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.cubageBooking"
                                              }
                                            }),
                                            _c("auto-number-input", {
                                              staticClass: "contract-input",
                                              attrs: {
                                                no: "97",
                                                precision: 3,
                                                min: 0,
                                                disabled: true
                                              },
                                              model: {
                                                value:
                                                  _vm.form.chargeWeightBooking,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "chargeWeightBooking",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.chargeWeightBooking"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c("auto-number-input", {
                                          staticClass: "contract-input",
                                          attrs: {
                                            precision: 3,
                                            min: 0,
                                            no: "141",
                                            disabled: true
                                          },
                                          model: {
                                            value: _vm.form.densityBooking,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "densityBooking",
                                                $$v
                                              )
                                            },
                                            expression: "form.densityBooking"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "queryJob.WarehousingInstructions"
                                      ),
                                      prop: "jobNo"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "align-items": "center"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-checkbox",
                                          {
                                            attrs: { no: "ownWarehouse" },
                                            model: {
                                              value: _vm.form.ownWarehouse,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "ownWarehouse",
                                                  $$v
                                                )
                                              },
                                              expression: "form.ownWarehouse"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "queryJob.GoodsIntoThisWarehouse"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-checkbox",
                                          {
                                            attrs: { no: "takePhotos" },
                                            model: {
                                              value: _vm.form.takePhotos,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "takePhotos",
                                                  $$v
                                                )
                                              },
                                              expression: "form.takePhotos"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("queryJob.NeedPhotos")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-checkbox",
                                          {
                                            attrs: { no: "documentsAttached" },
                                            model: {
                                              value: _vm.form.documentsAttached,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "documentsAttached",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.documentsAttached"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "queryJob.AttachedDocuments"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "queryJob.otherInstructions"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            no: "otherWarehouseNotes",
                                            type: "textarea",
                                            rows: 5,
                                            size: "min"
                                          },
                                          model: {
                                            value: _vm.form.otherWarehouseNotes,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "otherWarehouseNotes",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.otherWarehouseNotes"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "section",
                staticStyle: { width: "80%", "min-width": "1000px" }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("Warehouse.WarehouseInformation")))
                ]),
                _c(
                  "div",
                  {
                    staticClass: "form-row",
                    staticStyle: { display: "flex", "flex-direction": "row" }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: {
                          "label-width": "100px",
                          "label-position": "right"
                        }
                      },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "required",
                                    attrs: {
                                      label: _vm.$t("Warehouse.WarehouseNo"),
                                      prop: "warehouseNo"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        no: "10",
                                        disabled: !_vm.isEditing
                                      },
                                      on: {
                                        change: _vm.warehouseNoChargeHandler
                                      },
                                      model: {
                                        value: _vm.form.warehouseNo,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "warehouseNo", $$v)
                                        },
                                        expression: "form.warehouseNo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SeaExport.SerialNo"),
                                      prop: "serialNumber"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        no: "serialNumber",
                                        disabled: true
                                      },
                                      model: {
                                        value: _vm.form.serialNumber,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "serialNumber",
                                            $$v
                                          )
                                        },
                                        expression: "form.serialNumber"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width required",
                                    attrs: {
                                      label: _vm.$t("Warehouse.WarehouseName"),
                                      prop: "warehouse"
                                    }
                                  },
                                  [
                                    _c("el-cascader", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        no: "11",
                                        filterable: "",
                                        disabled: !_vm.isEditing,
                                        props: { checkStrictly: true },
                                        options:
                                          _vm.cargoTerminalOperationArray,
                                        clearable: ""
                                      },
                                      on: {
                                        change: function(p) {
                                          _vm.cargoTerminalOperationChange(p)
                                        }
                                      },
                                      model: {
                                        value: _vm.airportCargoTerminalDate,
                                        callback: function($$v) {
                                          _vm.airportCargoTerminalDate = $$v
                                        },
                                        expression: "airportCargoTerminalDate"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("Warehouse.Warehouseman"),
                                      prop: "warehouseOp"
                                    }
                                  },
                                  [
                                    _c("cargo-user-select", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        no: "12",
                                        "method-params": {
                                          officeId: _vm.form.opOffice,
                                          category: "role",
                                          shape: "warehouseOp"
                                        },
                                        "default-value":
                                          _vm.form.warehouseOp || "",
                                        disabled: !_vm.isEditing
                                      },
                                      on: {
                                        change: function(p) {
                                          _vm.form.warehouseOp = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm.isAe
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_EstimatedWarehousingTime"
                                          ),
                                          prop: "estimatedWarehousingTime"
                                        }
                                      },
                                      [
                                        _c("el-date-picker", {
                                          staticStyle: { width: "95%" },
                                          attrs: {
                                            no: "13",
                                            type: "datetime",
                                            disabled: true,
                                            "value-format":
                                              "yyyy-MM-dd HH:mm:ss",
                                            format: "yyyy-MM-dd HH:mm:ss"
                                          },
                                          model: {
                                            value:
                                              _vm.form.estimatedWarehousingTime,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "estimatedWarehousingTime",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.estimatedWarehousingTime"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "required",
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_ActualWarehousingTime"
                                      ),
                                      prop: "warehouseInDate"
                                    }
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        no: "14",
                                        type: "datetime",
                                        disabled: !_vm.isEditing,
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        format: "yyyy-MM-dd HH:mm:ss"
                                      },
                                      model: {
                                        value: _vm.form.warehouseInDate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "warehouseInDate",
                                            $$v
                                          )
                                        },
                                        expression: "form.warehouseInDate"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm.isAe
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_EstimatedDeliveryTime"
                                          ),
                                          prop: "estimatedDeliveryTime"
                                        }
                                      },
                                      [
                                        _c("el-date-picker", {
                                          staticStyle: { width: "95%" },
                                          attrs: {
                                            no: "15",
                                            type: "datetime",
                                            disabled: true,
                                            "value-format":
                                              "yyyy-MM-dd HH:mm:ss",
                                            format: "yyyy-MM-dd HH:mm:ss"
                                          },
                                          model: {
                                            value:
                                              _vm.form.estimatedDeliveryTime,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "estimatedDeliveryTime",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.estimatedDeliveryTime"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("Warehouse.ReceiptNo"),
                                      prop: "receiptNo"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        no: "17",
                                        disabled: !_vm.isEditing
                                      },
                                      model: {
                                        value: _vm.form.receiptNo,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "receiptNo", $$v)
                                        },
                                        expression: "form.receiptNo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.DeliveryCmp"),
                                      prop: "DeliveryCmp"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        no: "18",
                                        disabled: !_vm.isEditing
                                      },
                                      model: {
                                        value: _vm.form.deliveryCmp,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "deliveryCmp", $$v)
                                        },
                                        expression: "form.deliveryCmp"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.LicensePlate"),
                                      prop: "licensePlate"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        no: "19",
                                        disabled: !_vm.isEditing
                                      },
                                      model: {
                                        value: _vm.form.truckNo,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "truckNo", $$v)
                                        },
                                        expression: "form.truckNo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.Driver"),
                                      prop: "licensePlate"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        no: "20",
                                        disabled: !_vm.isEditing
                                      },
                                      model: {
                                        value: _vm.form.driver,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "driver", $$v)
                                        },
                                        expression: "form.driver"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.DriverPhone"),
                                      prop: "licensePlate"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        no: "21",
                                        disabled: !_vm.isEditing
                                      },
                                      model: {
                                        value: _vm.form.driverTel,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "driverTel", $$v)
                                        },
                                        expression: "form.driverTel"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("Warehouse.DeliveryMode"),
                                      prop: "outType"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "95%" },
                                        attrs: {
                                          no: "23",
                                          clearable: "",
                                          disabled: true,
                                          placeholder: _vm.$t(
                                            "Message.PleaseSelect"
                                          ),
                                          size: "mini"
                                        },
                                        model: {
                                          value: _vm.form.outType,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "outType", $$v)
                                          },
                                          expression: "form.outType"
                                        }
                                      },
                                      _vm._l(
                                        _vm.WarehouseInState
                                          .WAREHOUSE_IN_OUT_TYPE,
                                        function(item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label:
                                                _vm.$store.getters.language ===
                                                "zh"
                                                  ? item.chineseName
                                                  : item.englishName,
                                              value: item.code
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_ActualDeliveryTime"
                                      ),
                                      prop: "warehouseOutDate"
                                    }
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        no: "16",
                                        type: "datetime",
                                        disabled: true,
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        format: "yyyy-MM-dd HH:mm:ss"
                                      },
                                      model: {
                                        value: _vm.form.warehouseOutDate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "warehouseOutDate",
                                            $$v
                                          )
                                        },
                                        expression: "form.warehouseOutDate"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.PalletSum"),
                                      prop: "palletSum"
                                    }
                                  },
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        no: "24",
                                        "controls-position": "right",
                                        max: 10,
                                        min: 0,
                                        precision: 0,
                                        disabled: true
                                      },
                                      model: {
                                        value: _vm.form.palletSum,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "palletSum", $$v)
                                        },
                                        expression: "form.palletSum"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "receiveDc" } },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        attrs: {
                                          no: "25",
                                          disabled: !_vm.isEditing
                                        },
                                        model: {
                                          value: _vm.form.receiveDc,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "receiveDc", $$v)
                                          },
                                          expression: "form.receiveDc"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("Warehouse.ReceiveDc"))
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "isBroken" } },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          no: "26",
                                          disabled: !_vm.isEditing
                                        },
                                        on: {
                                          change: _vm.checkboxChangeHandler
                                        },
                                        model: {
                                          value: _vm.form.broken,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "broken", $$v)
                                          },
                                          expression: "form.broken"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            style: _vm.$selectByLang(
                                              "",
                                              "width: 135px;overflow: hidden;text-overflow: ellipsis;"
                                            ),
                                            attrs: {
                                              title: _vm.$selectByLang(
                                                "",
                                                _vm.$t(
                                                  "Warehouse.IsNotComputationIsAffectedByDampness"
                                                )
                                              )
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "Warehouse.IsNotComputationIsAffectedByDampness"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "brokenNum" } },
                                  [
                                    _c("line-label", {
                                      attrs: {
                                        slot: "label",
                                        label: _vm.$t(
                                          "Warehouse.ComputationIsAffectedByDampnessNum"
                                        )
                                      },
                                      slot: "label"
                                    }),
                                    _c("el-input-number", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        no: "27",
                                        min: 0,
                                        max: 99999,
                                        "controls-position": "right",
                                        precision: 0,
                                        disabled: !(
                                          _vm.isEditing && _vm.form.broken
                                        )
                                      },
                                      model: {
                                        value: _vm.form.brokenQuantity,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "brokenQuantity",
                                            $$v
                                          )
                                        },
                                        expression: "form.brokenQuantity"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "isBroken" } },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        attrs: {
                                          no: "28",
                                          disabled: !_vm.isEditing
                                        },
                                        on: {
                                          change: _vm.checkboxChangeHandler
                                        },
                                        model: {
                                          value: _vm.form.sealCargo,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "sealCargo", $$v)
                                          },
                                          expression: "form.sealCargo"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("Warehouse.IsTheGoodsClosed")
                                          ) + " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.SealingWeight"),
                                      prop: "brokenNum"
                                    }
                                  },
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        no: "29",
                                        min: 0,
                                        max: 999999999999,
                                        "controls-position": "right",
                                        precision: 1,
                                        disabled: !(
                                          _vm.isEditing && _vm.form.sealCargo
                                        )
                                      },
                                      model: {
                                        value: _vm.form.sealWeight,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "sealWeight", $$v)
                                        },
                                        expression: "form.sealWeight"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t(
                                        "Warehouse.WarehouseInState"
                                      ),
                                      no: "WarehouseInState",
                                      prop: "WarehouseInState"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "95%" },
                                        attrs: {
                                          no: "30",
                                          clearable: "",
                                          disabled: true,
                                          placeholder: _vm.$t(
                                            "Message.PleaseSelect"
                                          ),
                                          size: "mini"
                                        },
                                        model: {
                                          value: _vm.form.state,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "state", $$v)
                                          },
                                          expression: "form.state"
                                        }
                                      },
                                      _vm._l(
                                        _vm.WarehouseInState
                                          .WAREHOUSE_STATE_LIST,
                                        function(item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label:
                                                _vm.$store.getters.language ===
                                                "zh"
                                                  ? item.chineseName
                                                  : item.englishName,
                                              value: item.code
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "licensePlate" } },
                                  [
                                    _c("line-label", {
                                      attrs: {
                                        slot: "label",
                                        label: _vm.$t(
                                          "Warehouse.DescriptionOfGoods"
                                        )
                                      },
                                      slot: "label"
                                    }),
                                    _c("el-input", {
                                      staticClass: "custom-textarea",
                                      staticStyle: {
                                        width: "95%",
                                        height: "64px"
                                      },
                                      attrs: {
                                        no: "31",
                                        type: "textarea",
                                        row: 3,
                                        disabled: !_vm.isEditing
                                      },
                                      model: {
                                        value: _vm.form.brokenDes,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "brokenDes", $$v)
                                        },
                                        expression: "form.brokenDes"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "Warehouse.HandlingOpinions"
                                      ),
                                      prop: "licensePlate"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "custom-textarea",
                                      staticStyle: {
                                        width: "95%",
                                        height: "64px"
                                      },
                                      attrs: {
                                        no: "32",
                                        type: "textarea",
                                        row: 3,
                                        disabled: !_vm.isEditing
                                      },
                                      model: {
                                        value: _vm.form.comments,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "comments", $$v)
                                        },
                                        expression: "form.comments"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.Remark"),
                                      prop: "licensePlate"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "custom-textarea",
                                      staticStyle: {
                                        width: "95%",
                                        height: "64px"
                                      },
                                      attrs: {
                                        no: "33",
                                        type: "textarea",
                                        row: 3,
                                        disabled: !_vm.isEditing
                                      },
                                      model: {
                                        value: _vm.form.remarks,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "remarks", $$v)
                                        },
                                        expression: "form.remarks"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "section",
                staticStyle: { width: "80%", "min-width": "1000px" }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("Warehouse.CargoDetails")))
                ]),
                _c(
                  "div",
                  { staticClass: "form-row grid-list" },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: {
                          "label-width": "100px",
                          "label-position": "left",
                          disabled: !_vm.isEditing
                        }
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "el-form",
                              { staticClass: "spacing" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "34",
                                      type: "primary",
                                      disabled: !_vm.isEditing
                                    },
                                    on: { click: _vm.addDetailHandler }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Warehouse.AddCargo")))]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "35",
                                      type: "danger",
                                      disabled: !_vm.isEditing
                                    },
                                    on: { click: _vm.delDetailHandler }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Warehouse.DeleteCargo"))
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c("cargo-ag-grid", {
                              ref: "goodsTable",
                              staticStyle: { height: "200px" },
                              attrs: {
                                "config-module": "0250326",
                                "grid-options": _vm.detailList.goodGridOptions,
                                "column-defs": _vm.goodsColumn,
                                "row-data": _vm.form.warehouseInDetailList || []
                              },
                              on: {
                                gridReady: function(params) {
                                  _vm.detailList.gridApi = params.api
                                }
                              }
                            }),
                            _c("el-form-item", { staticClass: "auto-width" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "title-row",
                                  staticStyle: {
                                    display: "flex",
                                    "text-align": "left"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        "font-weight": "normal",
                                        color: "#404144",
                                        "white-space": "nowrap",
                                        width: "130px",
                                        "text-align": "right"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_NetGrossWeight"
                                          )
                                        ) +
                                          _vm._s(
                                            _vm.openImperial ? "(LB)" : "(KG)"
                                          )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        "font-weight": "normal",
                                        color: "#404144",
                                        "white-space": "nowrap",
                                        width: "130px",
                                        "text-align": "right"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_GrossWeight2"
                                          ) + _vm.$t("CargoMsg.Cargo_Weight")
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        "font-weight": "normal",
                                        color: "#404144",
                                        "white-space": "nowrap",
                                        width: "130px",
                                        "text-align": "right"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.ChargedWeight")
                                        ) +
                                          _vm._s(
                                            _vm.openImperial ? "(LB)" : "(KG)"
                                          )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        "font-weight": "normal",
                                        color: "#404144",
                                        "white-space": "nowrap",
                                        width: "130px",
                                        "text-align": "right"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("SeaExport.Quantity"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        "font-weight": "normal",
                                        color: "#404144",
                                        "white-space": "nowrap",
                                        width: "130px",
                                        "text-align": "right"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("SeaExport.Cubage")) +
                                          _vm._s(
                                            _vm.openImperial ? "(CFT)" : "(CBM)"
                                          )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "auto-width",
                                attrs: { label: " " }
                              },
                              [
                                _c("el-input-number", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.openImperial,
                                      expression: "!openImperial"
                                    }
                                  ],
                                  attrs: {
                                    no: "weightSum",
                                    disabled: true,
                                    "controls-position": "right",
                                    precision: 2,
                                    min: 0,
                                    max: 999999999
                                  },
                                  model: {
                                    value: _vm.form.weightSum,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "weightSum", $$v)
                                    },
                                    expression: "form.weightSum"
                                  }
                                }),
                                _c("el-input-number", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.openImperial,
                                      expression: "openImperial"
                                    }
                                  ],
                                  attrs: {
                                    no: "weightSumImperial",
                                    disabled: true,
                                    "controls-position": "right",
                                    precision: 2,
                                    min: 0,
                                    max: 999999999
                                  },
                                  model: {
                                    value: _vm.form.weightSumImperial,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "weightSumImperial",
                                        $$v
                                      )
                                    },
                                    expression: "form.weightSumImperial"
                                  }
                                }),
                                _c("el-input-number", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.openImperial,
                                      expression: "!openImperial"
                                    }
                                  ],
                                  attrs: {
                                    no: "grossWeightSum",
                                    disabled: true,
                                    "controls-position": "right",
                                    precision: 2,
                                    min: 0,
                                    max: 999999999
                                  },
                                  model: {
                                    value: _vm.form.grossWeightSum,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "grossWeightSum", $$v)
                                    },
                                    expression: "form.grossWeightSum"
                                  }
                                }),
                                _c("el-input-number", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.openImperial,
                                      expression: "openImperial"
                                    }
                                  ],
                                  attrs: {
                                    no: "grossWeightSumImperial",
                                    disabled: true,
                                    "controls-position": "right",
                                    precision: 2,
                                    min: 0,
                                    max: 999999999
                                  },
                                  model: {
                                    value: _vm.form.grossWeightSumImperial,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "grossWeightSumImperial",
                                        $$v
                                      )
                                    },
                                    expression: "form.grossWeightSumImperial"
                                  }
                                }),
                                _c("el-input-number", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.openImperial,
                                      expression: "!openImperial"
                                    }
                                  ],
                                  attrs: {
                                    no: "chargedWeight",
                                    disabled: true,
                                    "controls-position": "right",
                                    precision: 2,
                                    min: 0,
                                    max: 999999999
                                  },
                                  model: {
                                    value: _vm.form.chargedWeightSum,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "chargedWeightSum",
                                        $$v
                                      )
                                    },
                                    expression: "form.chargedWeightSum"
                                  }
                                }),
                                _c("el-input-number", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.openImperial,
                                      expression: "openImperial"
                                    }
                                  ],
                                  attrs: {
                                    no: "chargedWeightSumImperial",
                                    disabled: true,
                                    "controls-position": "right",
                                    precision: 2,
                                    min: 0,
                                    max: 999999999
                                  },
                                  model: {
                                    value: _vm.form.chargedWeightSumImperial,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "chargedWeightSumImperial",
                                        $$v
                                      )
                                    },
                                    expression: "form.chargedWeightSumImperial"
                                  }
                                }),
                                _c("el-input-number", {
                                  attrs: {
                                    no: "quantitySum",
                                    disabled: true,
                                    "controls-position": "right",
                                    min: 0,
                                    max: 999999999,
                                    precision: 0
                                  },
                                  model: {
                                    value: _vm.form.quantitySum,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "quantitySum", $$v)
                                    },
                                    expression: "form.quantitySum"
                                  }
                                }),
                                _c("el-input-number", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.openImperial,
                                      expression: "!openImperial"
                                    }
                                  ],
                                  attrs: {
                                    no: "cubageSum",
                                    disabled: true,
                                    "controls-position": "right",
                                    precision: 3,
                                    min: 0,
                                    max: 999999999
                                  },
                                  model: {
                                    value: _vm.form.cubageSum,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "cubageSum", $$v)
                                    },
                                    expression: "form.cubageSum"
                                  }
                                }),
                                _c("el-input-number", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.openImperial,
                                      expression: "openImperial"
                                    }
                                  ],
                                  attrs: {
                                    no: "cubAgeSumImperial",
                                    disabled: true,
                                    "controls-position": "right",
                                    precision: 3,
                                    min: 0,
                                    max: 999999999
                                  },
                                  model: {
                                    value: _vm.form.cubAgeSumImperial,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "cubAgeSumImperial",
                                        $$v
                                      )
                                    },
                                    expression: "form.cubAgeSumImperial"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "section",
                staticStyle: { width: "80%", "min-width": "1000px" }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("Warehouse.CargoPhotos")))
                ]),
                _c(
                  "div",
                  { staticClass: "form-row grid-list" },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: {
                          "label-width": "100px",
                          "label-position": "left",
                          disabled: !_vm.isEditing
                        }
                      },
                      [
                        _c(
                          "el-form",
                          { staticClass: "spacing" },
                          [
                            _c(
                              "el-upload",
                              {
                                staticStyle: {
                                  display: "inline-block",
                                  "margin-right": "5px"
                                },
                                attrs: {
                                  action:
                                    _vm.URL.warehouseIn
                                      .uploadFileForWarehouseIn +
                                    "?warehouseInUuid=" +
                                    _vm.warehouseInUuid,
                                  headers: {
                                    sessionId: _vm.$store.getters.token
                                  },
                                  "show-file-list": false,
                                  "on-success": _vm.uploadSuccess,
                                  "on-change": _vm.toChooseFile,
                                  disabled: !_vm.isEditing
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "42",
                                      type: "primary",
                                      disabled: !_vm.isEditing
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Warehouse.SelectFile"))
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "danger",
                                  disabled: !_vm.isEditing,
                                  no: "43"
                                },
                                on: { click: _vm.delPhotoHandler }
                              },
                              [_vm._v(_vm._s(_vm.$t("Warehouse.DeleteFile")))]
                            )
                          ],
                          1
                        ),
                        _c("cargo-ag-grid", {
                          ref: "photosList",
                          attrs: {
                            "config-module": "0250327",
                            "grid-options": _vm.photoList.gridOptions,
                            "column-defs": _vm.photoList.photoColumn,
                            "row-data": _vm.form.businessDocumentVOList
                          },
                          on: {
                            gridReady: function(params) {
                              _vm.photoList.gridApi = params.api
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "section",
                staticStyle: { width: "80%", "min-width": "1000px" }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("Warehouse.OperationRequirements")))
                ]),
                _c(
                  "div",
                  { staticClass: "form-row grid-list" },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: {
                          "label-width": "100px",
                          "label-position": "left",
                          disabled: !_vm.isEditing
                        }
                      },
                      [
                        _c(
                          "div",
                          [
                            _c("cargo-ag-grid", {
                              ref: "opList",
                              attrs: {
                                "config-module": "9300014",
                                "grid-options": _vm.opList.options,
                                "column-defs": _vm.opList.opColumn,
                                "row-data": _vm.form.operationRequirementVOList
                              },
                              on: {
                                gridReady: function(params) {
                                  _vm.opList.gridApi = params.api
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ])
        ],
        1
      ),
      _vm.fileTypeEditor.visible
        ? _c("mx-file-type-editor", {
            attrs: {
              visible: _vm.fileTypeEditor.visible,
              lob: _vm.fileTypeEditor.lob,
              "file-id": _vm.fileTypeEditor.fileId,
              "file-category": _vm.fileTypeEditor.fileCategory
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.fileTypeEditor, "visible", $event)
              },
              saveFileType: _vm.itemEditEndHandler
            }
          })
        : _vm._e(),
      _vm.jobNosWindow.visible
        ? _c("job-nos-window", {
            attrs: {
              visible: _vm.jobNosWindow.visible,
              "job-nos": _vm.jobNosWindow.jobs
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.jobNosWindow, "visible", $event)
              },
              selectJobNoHandler: _vm.selectJobNoHandler
            }
          })
        : _vm._e(),
      _vm.dimensionsDialog.visible
        ? _c("dimensions-dialog", {
            attrs: {
              visible: _vm.dimensionsDialog.visible,
              uuid: _vm.dimensionsDialog.uuid,
              "single-weight": _vm.dimensionsDialog.singleWeight,
              dimension: _vm.dimensionsDialog.dimension,
              "open-imperial": _vm.openImperial
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.dimensionsDialog, "visible", $event)
              },
              sizeData: _vm.sizeDataHandler,
              close: function($event) {
                _vm.dimensionsDialog.visible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }